import { serviceBillingTriggerOptions } from "../../business-logic/billingLogic";
import { ServiceCostType } from "../../models/service-cost";
import { BillingTriggerType } from "../../types/api.model";
const pricingTypeMap = {
  range: ServiceCostType.Range,
  fixed: ServiceCostType.Fixed,
  unit: ServiceCostType.Variable,
  hour: ServiceCostType.Variable
};
const billingTriggerMap = {
  ongoing: BillingTriggerType.Ongoing,
  approval: BillingTriggerType.OnApproval,
  manualFixed: BillingTriggerType.OneTimeManual,
  manualVariable: BillingTriggerType.OneTimeManual,
  oneTimeInStages: BillingTriggerType.OneTimeInStages
};
export function getBillingTriggerOptionsForFormState(_ref) {
  let {
    t,
    data,
    serviceOrigin,
    isExistingService,
    featureFlags
  } = _ref;
  const {
    recurrencePeriod,
    pricing,
    trigger
  } = data;
  return serviceBillingTriggerOptions({
    t,
    featureFlags,
    isExistingService,
    isFromAgreement: serviceOrigin === 'agreement',
    recurrencePeriod: recurrencePeriod === 'onetime' || recurrencePeriod === 'inStages' || recurrencePeriod === 'onDemand' ? null : recurrencePeriod,
    pricingType: pricingTypeMap[pricing],
    billingTrigger: billingTriggerMap[trigger]
  });
}
export function getUpdatedTriggerIfInvalid(_ref2) {
  let {
    t,
    currentTrigger,
    pricing,
    recurrencePeriod,
    serviceOrigin,
    isExistingService,
    featureFlags
  } = _ref2;
  const newOptions = getBillingTriggerOptionsForFormState({
    t,
    data: {
      recurrencePeriod,
      pricing,
      trigger: currentTrigger
    },
    serviceOrigin,
    isExistingService,
    featureFlags
  });

  // If current trigger is not in available options, return first available option
  if (newOptions.every(opt => opt.value !== currentTrigger)) {
    var _newOptions$;
    return ((_newOptions$ = newOptions[0]) === null || _newOptions$ === void 0 ? void 0 : _newOptions$.value) || 'manualVariable';
  }
  return null;
}